// Grenew Website Mock Data - Updated Content

export const companyInfo = {
  name: "Grenew",
  tagline: "Reclaim. Recycle. Reimagine.",
  description: "Grenew delivers sustainable circular economy solutions across the UAE — from IT asset disposition to certified e-waste recycling and material recovery.",
  logo: "https://customer-assets.emergentagent.com/job_2d31ec28-4a6c-40e1-b5d9-0aecc911288e/artifacts/j2qgbysz_cdjk0bag_Asset%209.png",
  logoIcon: "https://customer-assets.emergentagent.com/job_2d31ec28-4a6c-40e1-b5d9-0aecc911288e/artifacts/sedrtvmd_xdgptttk_Asset%2010.png",
  location: "LB07006, Jebel Ali Freezone Authority Dubai, United Arab Emirates",
  headOffice: "Post Box-28411, 202, The Business Center, Burdubai, Dubai, UAE",
  facility2: "Post Box - 50751, Plot No. STL-16, STL-17 Hamriyah Free Zone, Phase 2 Sharjah, UAE",
  facility2MapUrl: "https://www.google.com/maps/search/Hamriyah+Free+Zone+Phase+2+Sharjah+UAE",
  facility2WazeUrl: "https://waze.com/ul?q=Hamriyah+Free+Zone+Sharjah",
  hotline: "+971 54 257 2243",
  email: "info@grenewfze.com",
  whatsapp: "+971 54 257 2243",
  facilityMapUrl: "https://www.google.com/maps/search/Jebel+Ali+Freezone+Authority+Dubai+UAE",
  officeMapUrl: "https://www.google.com/maps/search/The+Business+Center+Burdubai+Dubai+UAE",
  facilityWazeUrl: "https://waze.com/ul?q=Jebel+Ali+Freezone+Dubai",
  officeWazeUrl: "https://waze.com/ul?q=The+Business+Center+Burdubai+Dubai",
  social: {
    instagram: "https://www.instagram.com/grenewfze",
    linkedin: "https://www.linkedin.com/company/grenew-fze",
    facebook: "https://www.facebook.com/people/Grenew-FZE/61581337076900/"
  }
};

export const stats = [
  { value: "150,000+", label: "Sq Ft Facility", suffix: "" },
  { value: "50,000", label: "MT Annual Capacity", suffix: "" },
  { value: "500+", label: "Enterprise Clients", suffix: "" },
  { value: "ISO", label: "Certified Operations", suffix: "" }
];

export const services = [
  {
    id: "itad",
    title: "IT Asset Disposition (ITAD)",
    shortTitle: "ITAD",
    tagline: "Secure retirement of your IT assets — without risk.",
    description: "In today's fast-moving digital environment, managing the full lifecycle of IT assets is no longer optional. Grenew's IT Asset Disposition services ensure your outdated or unused equipment is handled securely, compliantly and in an environmentally responsible manner.",
    subDescription: "From certified data destruction and secure logistics to resale and recycling, we manage the entire process end-to-end — so your teams can stay focused on business, not disposal.",
    benefits: [
      "Secure data wiping and physical destruction",
      "Certified and compliant disposal",
      "Asset tracking and reporting",
      "Resale and value recovery",
      "Environmental compliance across UAE regulations"
    ],
    whyMatters: [
      "Protects sensitive data",
      "Reduces environmental impact",
      "Ensures regulatory compliance",
      "Improves asset visibility",
      "Unlocks residual value from old equipment"
    ],
    useCases: [
      "Technology refresh and infrastructure upgrades",
      "Replacement of faulty equipment under warranty",
      "Compliant disposal of irreparable hardware",
      "Trade-in and resale of surplus assets",
      "Return and closure of leased equipment"
    ],
    icon: "Server"
  },
  {
    id: "ewaste",
    title: "Eco-Friendly E-Waste Recycling",
    shortTitle: "E-Waste Recycling",
    tagline: "Making responsible electronics disposal simple across the UAE.",
    description: "Grenew provides professional, eco-friendly electronic waste recycling services designed for enterprises, households and institutions.",
    subDescription: "Our teams collect, sort and process electronic waste through certified facilities — ensuring harmful substances are safely handled and valuable materials are recovered.",
    benefits: [
      "Computers and laptops",
      "Smartphones and tablets",
      "Household appliances",
      "Special and hazardous electronic waste"
    ],
    approach: [
      "Secure collection and transport",
      "Sorting and processing through approved recycling plants",
      "Data destruction where required",
      "Full regulatory compliance across Dubai and the UAE"
    ],
    lifecycle: [
      { step: "Production", desc: "Resource-intensive materials and energy" },
      { step: "Use", desc: "Energy consumption and device lifespan" },
      { step: "Disposal", desc: "Safe retirement of equipment" },
      { step: "Recycling", desc: "Recovery of metals and materials" },
      { step: "Refurbishing", desc: "Extending usable life of devices" }
    ],
    icon: "Recycle"
  },
  {
    id: "dismantling",
    title: "Dismantling & Material Recovery",
    shortTitle: "Material Recovery",
    tagline: "Recover value. Reduce waste. Enable circular infrastructure.",
    description: "Grenew provides professional dismantling and material recovery services across Dubai and the UAE.",
    subDescription: "Our teams carefully deconstruct equipment, systems and end-of-life assets to recover metals, plastics and electronic components — ensuring safe operations, regulatory compliance and maximum material recovery.",
    supports: [
      "Infrastructure redevelopment",
      "Industrial upgrades",
      "Asset decommissioning",
      "Sustainability and ESG targets"
    ],
    valuePromise: [
      "Door-to-door collection",
      "Full traceability and digital tracking",
      "Transparent material pricing",
      "Environmentally safe disposal",
      "Issuance of destruction and recovery certificates"
    ],
    process: [
      "Collection of end-of-life assets",
      "Inspection and material assessment",
      "Controlled dismantling",
      "Component and material separation",
      "Material recovery and refinement",
      "Recycling and reuse routing",
      "Safe disposal of non-recoverable waste",
      "Reporting and continuous improvement"
    ],
    icon: "Gem"
  },
  {
    id: "rscm",
    title: "Reverse Supply Chain Management for OEMs",
    shortTitle: "Reverse Supply Chain",
    tagline: "Built for manufacturers. Designed for circular growth.",
    description: "Grenew supports Original Equipment Manufacturers and distributors with end-to-end reverse supply chain management across the UAE.",
    subDescription: "We manage product returns, inspection and refurbishment, repair and remanufacturing, recycling and compliant disposal — all through controlled, traceable and value-driven workflows.",
    capabilities: [
      "Return and take-back programs",
      "Refurbishment and re-certification",
      "Repair and remanufacturing",
      "Recycling and waste processing",
      "Closed-loop supply chain integration"
    ],
    whyGrenew: [
      "Deep local regulatory expertise across Dubai and the UAE",
      "Strong sustainability and circular economy alignment",
      "Optimised cost and recovery models",
      "Advanced operational and tracking systems",
      "Flexible, client-specific operating models"
    ],
    workflow: [
      "Collection of returned or unused products",
      "Inspection and classification",
      "Reuse, repair, recycle or disposal decisions",
      "Transportation to certified facilities",
      "Reprocessing and refurbishment",
      "Redistribution into the market",
      "Final compliant disposal",
      "Performance reporting and optimisation"
    ],
    icon: "RotateCcw"
  }
];

export const secureOperations = [
  {
    id: "deinstallation",
    title: "Asset De-installation",
    description: "Professional, on-site de-installation of IT and electronic assets — including disconnection, packaging and compliant transportation.",
    icon: "Wrench"
  },
  {
    id: "data-destruction",
    title: "Data Destruction & Sanitisation",
    description: "Permanently erase or destroy sensitive data using certified software and physical destruction methods. Certificates of destruction issued for full compliance and audit readiness.",
    icon: "ShieldCheck"
  },
  {
    id: "logistics",
    title: "Logistics & Collection",
    description: "Secure pickup, compliant transport and certified delivery to authorised recycling and processing centres.",
    icon: "Truck"
  },
  {
    id: "remarketing",
    title: "Remarketing & Value Recovery",
    description: "Refurbish and resell eligible assets through global secondary markets — helping organisations recover residual value while supporting sustainability.",
    icon: "TrendingUp"
  },
  {
    id: "disposition",
    title: "Final Disposition & Recycling",
    description: "Recovered materials are processed responsibly to prevent environmental harm and support the circular economy.",
    icon: "Recycle"
  }
];

export const whyGrenew = {
  headline: "Because sustainability is not a campaign. It is infrastructure.",
  points: [
    "High recycling and recovery rates",
    "Strong compliance frameworks",
    "Secure handling of data and proprietary assets",
    "Certified downstream partners",
    "Transparent reporting",
    "Circular-first design philosophy"
  ],
  statement: "We help organisations move from disposal to regeneration — without operational friction."
};

export const processSteps = [
  {
    step: 1,
    title: "Collection & Logistics",
    description: "Secure pickup and transportation from your location with full chain of custody documentation."
  },
  {
    step: 2,
    title: "Sorting & Assessment",
    description: "Comprehensive inventory and condition assessment of all assets received."
  },
  {
    step: 3,
    title: "Secure Data Destruction",
    description: "Certified data wiping or physical destruction with compliance certificates."
  },
  {
    step: 4,
    title: "Dismantling",
    description: "Systematic separation of components for optimal material recovery."
  },
  {
    step: 5,
    title: "Material Recovery",
    description: "Extraction of valuable metals, plastics, and recyclable materials."
  },
  {
    step: 6,
    title: "Recycling & Remarketing",
    description: "Responsible processing or refurbishment for secondary markets."
  },
  {
    step: 7,
    title: "Certification & Reporting",
    description: "Complete compliance documentation and environmental impact reports."
  }
];

export const industries = [
  { name: "Telecom", icon: "Radio" },
  { name: "IT & Technology", icon: "Monitor" },
  { name: "Banking & Finance", icon: "Building" },
  { name: "E-commerce", icon: "ShoppingCart" },
  { name: "Education", icon: "GraduationCap" },
  { name: "Government", icon: "Landmark" }
];

export const sustainabilityStats = [
  {
    stat: "62 Mt",
    label: "Global E-Waste 2022",
    growth: "→ 82 Mt by 2030"
  },
  {
    stat: "22%",
    label: "Global Recycling Rate",
    growth: "<1% recycled responsibly"
  },
  {
    stat: "1.13M",
    label: "Tons E-Waste in GCC",
    growth: "Annual generation"
  },
  {
    stat: "134K",
    label: "Tons in UAE",
    growth: "17.2 kg per capita"
  }
];

export const futureInitiatives = [
  {
    title: "Battery Recycling",
    description: "EVs and portable device batteries",
    icon: "Battery"
  },
  {
    title: "Solar Panel Recycling",
    description: "Photovoltaic module recovery",
    icon: "Sun"
  },
  {
    title: "AI & Crypto Server Recycling",
    description: "High-performance computing infrastructure",
    icon: "Cpu"
  }
];

export const clients = [
  "Microsoft",
  "Ericsson",
  "Huawei",
  "Carrefour",
  "Noon",
  "Amazon",
  "NBF"
];

export const certifications = [
  "ISO 9001",
  "ISO 14001",
  "ISO 27001",
  "ISO 45001"
];

export const blogPosts = [
  {
    id: 1,
    title: "The UAE's EPR Framework: What Businesses Must Prepare For",
    category: "EPR: E-Waste & Sustainability",
    date: "2025-08-10",
    excerpt: "Understanding the Extended Producer Responsibility framework and its implications for UAE businesses."
  },
  {
    id: 2,
    title: "The GCC's Next Big Regulatory Push",
    category: "EPR: E-Waste & Sustainability",
    date: "2025-08-05",
    excerpt: "Regional regulations are evolving rapidly. Here's what to expect in the coming years."
  },
  {
    id: 3,
    title: "Why Data Destruction Certificates Are More Than Just Paper",
    category: "Corporate IT & Data Security",
    date: "2025-07-28",
    excerpt: "The critical importance of certified data destruction in today's compliance landscape."
  },
  {
    id: 4,
    title: "How OEMs Unlock Value Through Reverse Logistics",
    category: "OEM & Reverse Supply Chain",
    date: "2025-07-20",
    excerpt: "Strategies for maximizing returns from reverse supply chain operations."
  },
  {
    id: 5,
    title: "The Future of Battery & Solar Panel Recycling in the GCC",
    category: "Technology & Innovation",
    date: "2025-07-15",
    excerpt: "Emerging technologies and infrastructure for next-generation recycling."
  }
];

export const blogCategories = [
  "EPR: E-Waste & Sustainability",
  "Corporate IT & Data Security",
  "OEM & Reverse Supply Chain",
  "Technology & Innovation",
  "Community & Awareness"
];

export const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { 
    label: "Services", 
    path: "/services",
    dropdown: true
  },
  { label: "Process", path: "/process" },
  { label: "Sustainability", path: "/sustainability" },
  { label: "Insights", path: "/insights" },
  { label: "Contact", path: "/contact" }
];

export const aboutContent = {
  headline: "Who We Are",
  paragraphs: [
    "Born in the UAE, Grenew FZE is a leader in circular economy solutions, helping enterprises responsibly manage end-of-life electronic waste.",
    "Leveraging the UAE's strategic location and infrastructure, we serve as a trusted partner to global and regional businesses including industry leading Fortune 500 businesses.",
    "Backed by internationally renowned certifications, we blend sustainability, security, and innovation to maximize the value of discarded technology.",
    "We operate with the sole objective of furthering the position of the United Arab Emirates — one of the world's most advanced trade and logistics hubs — in Sustainability Leadership."
  ],
  facility: {
    headline: "Our Facility",
    location: "Located in Hamriyah Free Zone, Sharjah",
    stats: [
      "150,000+ sq ft world-class recycling center",
      "50,000 MT annual processing capacity"
    ]
  },
  focus: {
    headline: "Our Focus",
    items: [
      "Enabling Sustainability aligned with UAE's Net Zero 2050 Strategy",
      "IP protection through certified data erasure & asset disposal",
      "End-to-end transparency with digital reporting for effective and responsible recycling"
    ]
  }
};
